/*=========================================================================================
  File Name: modulePaymentStatusActions.js
  Description: PaymentStatus Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  AddPaymentStatus({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/PaymentStatus/AddPaymentStatus", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.Data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetAllPaymentStatus({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/PaymentStatus/GetAllPaymentStatuses")
        .then((response) => {
          commit('SET_PaymentStatus', response.data.Data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  UpdatePaymentStatus({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/PaymentStatus/UpdatePaymentStatus?ID="+item.ID, item)
        .then((response) => {
          commit('UPDATE_PaymentStatus', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetPaymentStatus({ commit }, itemid) {
    //debugger
    return new Promise((resolve, reject) => {
      axios.get("api/PaymentStatus/GetPaymentStatus?ID="+ itemid)
        .then((response) => {
          //debugger
          commit('SET_PaymentStatus', response.data.Data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
   
  DeletePaymentStatus({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/PaymentStatus/DeletePaymentStatus?ID="+item.ID)
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
